export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

    $('.landing__arrow').click(function(event) {
      // Preventing default action of the event
      event.preventDefault();

      
    if ($(window).width() < 812) {
      // Getting the height of the document
      var n = $(document).height();
      $('html, body').animate({ scrollTop: n }, 1000);  

     } else { 
      $('.content-info').toggleClass('showDetails');
      //$('.landing__arrow').toggleClass('rotate');
    }

    });

    $(window).resize(function() {
      //$('.landing_arrow').removeClass('rotate');
      $('.content-info').removeClass('showDetails');
    });


  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js